import React, { useState } from "react";

const GST = () => {

    const [openSection, setOpenSection] = useState(null);
    const [openSection2, setOpenSection2] = useState(null);
    
      const toggleSection2 = (section) => {
        setOpenSection2(openSection2 === section ? null : section);
      };
      const toggleSection = (section) => {
        setOpenSection(openSection === section ? null : section);
      };
  const handleAppointmentClick = () => {
    window.open(
      "http://topmate.io/sanjay_nathani/?utm_source=topmate&utm_medium=popup&utm_campaign=Page_Ready",
      "_blank"
    );
  };
  return (
    <div className="p-8 bg-gray-100">
      {/* Title Section */}
      <h1 className="text-3xl font-bold text-center mb-6">GST Registration</h1>
      <p className="text-gray-700 mb-6">
        GST registration is compulsory in India under the following circumstances:
      </p>

      {/* Circumstances List */}
      <ul className="list-disc pl-5 text-gray-700 mb-6">
        <li>
          When your aggregate turnover exceeds the threshold limit:
          <ul className="list-disc pl-5">
            <li>
              For supply of goods: Rs. 40 lakhs (Rs. 20 lakhs for special category states)
            </li>
            <li>
              For supply of services: Rs. 20 lakhs (Rs. 10 lakhs for special category states)
            </li>
          </ul>
        </li>
        <li>
          When you make inter-state supplies: If you supply goods or services to customers in another state, you need to register for GST, irrespective of your turnover.
        </li>
        <li>
          When you supply goods through an e-commerce operator: If you sell goods through online platforms like Amazon or Flipkart, you need to register for GST.
        </li>
        <li>Other cases:</li>
        <ul className="list-disc pl-5">
          <li>When you are required to pay tax under reverse charge mechanism</li>
          <li>When you are a non-resident taxable person</li>
          <li>When you are an agent of a registered principal</li>
        </ul>
      </ul>

      {/* Documents Required Section
      <div className="bg-gray-50 p-4 rounded-lg shadow-md mt-6">
      <button
          onClick={() => setIsDocumentsOpen(!isDocumentsOpen)}
          className="flex justify-between w-full text-left text-lg font-semibold text-blue-800 hover:text-blue-600 "
        >
          1. Documents Required
          <span>{isDocumentsOpen ? "-" : "+"}</span>
        </button>
        {isDocumentsOpen && (
          <ul className="list-disc pl-5 mt-2 text-black">
            <li>PAN Card of the business or applicant.</li>
            <li>Aadhaar Card of the applicant.</li>
            <li>Proof of business registration or incorporation certificate.</li>
            <li>Identity and address proof of promoters/directors with photographs.</li>
            <li>Address proof of the place of business.</li>
            <li>Bank account statement/cancelled cheque.</li>
            <li>Digital Signature Certificate (DSC) for companies and LLPs.</li>
          </ul>
        )}

      </div> */}


<div className="space-y-4 mx-10 lg:mx-40">
        {/* Section 1 */}
        <div
          className={`border rounded-lg ${
            openSection === 1 ? "bg-blue-100" : "bg-[#005A8C]"
          }`}
        >
          <button
            onClick={() => toggleSection(1)}
            className="w-full text-left px-4 py-3 text-white font-bold flex justify-between items-center"
          >
            1. Documents Required
            <span>{openSection === 1 ? "-" : "+"}</span>
          </button>
          {openSection === 1 && (
             <ul className="list-disc pl-5 mt-2 bg-white text-black">
             <li>PAN Card of the business or applicant.</li>
             <li>ADDRESS AND IDENTITY PROOF ALONG WITH PHOTOGRAPHS: </li>
             <p>Following can be admitted and submitted as Identity Proof such as (Passport, Voter ID card, PAN, Aadhar Card, Driving License) and; In case of Address Proof (passport, Aadhar Card, Driving License, Voters Identity Card and Ration Card) Further, the persons who mandatorily need to submit the above-mentioned documents are as follows:-</p>
             <li>Company – Managing Director, Directors and the Authorized Person</li>
             <li>Hindu Undivided Family – Karta</li>
             <li>Proprietary Concern – Proprietor</li>
             <li>Local Authority – CEO or his equivalent	</li>
             <li>Statutory Body – CEO or his equivalent</li>
             <li>Trust – Managing Trustee, Trustees, and Authorized Person</li>
             <li>Partnership Firm / LLP – Managing/Authorized/Designated Partners (personal details of all partners are required to be submitted but photographs of only 10 partners including that of Managing Partner is to be submitted);</li>
             <li>Association of Persons or Body of Individuals –Members of Managing Committee (personal details of all members are required to be submitted but photographs of only 10 members including that of Chairman is to be submitted)</li>
             <li>Others – persons in charge</li>
           </ul>
          )}
        </div>
        <div
          className={`border rounded-lg ${
            openSection2 === 1 ? "bg-blue-100" : "bg-[#005A8C]"
          }`}
        >
          <button
            onClick={() => toggleSection2(1)}
            className="w-full text-left px-4 py-3 text-white font-bold flex justify-between items-center"
          >
            2.Business Registration Document
            <span>{openSection2 === 1 ? "-" : "+"}</span>
          </button>
          {openSection2 === 1 && (
             <ul className="list-disc pl-5 mt-2 bg-white text-black">
             <li className="font-bold">ADDRESS PROOF FOR PLACE OF BUSINESS</li>
             <p>In the GST Registration application, an address proof for all places of business is to be submitted. 
                Following documents are admissible for GST Registration:-</p>
             <li className="font-bold">For Rented or Leased Premises-</li> Copy of the valid rental agreement with a supporting document of ownership of the premises of the Lessor i.e. either copy of Latest Property Tax Receipt, Municipal Khata, Electricity Bill. In case of unavailability of the rental agreement or lease deed, an affidavit along with a supporting document in the possession of the premises like a copy of the electricity bill, etc can be used.
             <li className="font-bold">Other Cases-</li>Copy of consent letter of the owner of premises along with a supporting document of ownership of premises of the consenter like a copy of the electricity bill, Municipal Khata.
             <li className="font-bold">PROOF OF BANK ACCOUNT</li>
             <p>Scanned copy of either following documents:-</p>
             <li>First and relevant page of Passbook</li>
             <li>The relevant page of bank statement</li>
             <li>Cancelled cheque bearing the name of Proprietor or business entity, Bank Account No., IFSC, MICR, and Bank Branch details including code.2</li>
           </ul>
          )}
        </div>
        </div>

      {/* Get in Touch Section */}
      <div className="bg-white shadow-md rounded-lg p-4 mt-6">
        <h2 className="text-lg font-semibold mb-2 ">Get in touch</h2>
        <p className="text-gray-700 mb-4 ">
          If you have any queries or questions, please reach out to us by clicking on the contact button and filling out the form.
        </p>
        <div className="flex space-x-4">
          <button onClick={handleAppointmentClick}  className="bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600">
            Make Appointment
          </button>
          <button className="bg-[#005A8C] text-white px-4 py-2 rounded hover:bg-blue-600">
            Contact Us
          </button>
        </div>
      </div>
    </div>
  );
};

export default GST;
